import Reflux from 'reflux';

export default Reflux.createActions([
  'init',
  'trackLink',
  'trackContainerLinks',
  'pageLink',
  'updateLinks',
  'pageView',
  'track'
]);



// WEBPACK FOOTER //
// ./medscape_modules/tracking/actions.js